<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.ppa_perfiles.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>

              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>

            <v-col cols="12">
                <v-container>
                  <v-row>      
                    <v-col cols=12>
                      <div id="app2">
                          <v-grid 
                          theme="material" 
                          :source="datos" 
                          :columns="columns"
                          canFocus=true
                            range=true
                            useClipboard=true
                            :readonly="this.disabled"
                            filter=true
                            resize=true
                            @afteredit="handleCellEdit"
                          ></v-grid>      
                      </div>
                    </v-col>      
                  </v-row>
                </v-container>

            </v-col>
            </v-row>
            <v-dialog v-model="showAlert" max-width="400">
                <v-card>
                    <v-card-title class="headline">Advertencia</v-card-title>
                    <v-card-text>
                    {{ error_msg }}
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showAlert = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>
        </v-card-text>
    </v-card>


</template>

<script>
import VGrid from "@revolist/vue3-datagrid";
import Swal from 'sweetalert2';
//import ComponenteLoading from './ComponenteLoading.vue';
export default {

  props: {
    modelValue: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
    disabled:{
      type:Boolean,
      default:false,
    }
  },

  data() {
    return {

      traducciones:{
        periodo:[],
        ppa1:[],
        ppa2:[],
        ppa3:[],

      },
      showAlert:false,
      error_msg:"",

      loading: false,

      columns: [
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.hora'),
          prop: "periodo",
          size: 90
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa1'),
          prop: "ppa1",
          size: 200,
          cellTemplate: (h, props) => {
            const value = props.model[props.prop];
            return h('span', {}, 
              typeof value === 'number'
                ? value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 })
                : (value === 0 ? '0' : (value !== undefined && value !== null ? value : '0'))
            );
          }
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa2'),
          prop: "ppa2",
          size: 200,
          cellTemplate: (h, props) => {
            const value = props.model[props.prop];
            return h('span', {}, 
              typeof value === 'number'
                ? value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 })
                : (value === 0 ? '0' : (value !== undefined && value !== null ? value : '0'))
            );
          }
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa3'),
          prop: "ppa3",
          size: 200,
          cellTemplate: (h, props) => {
            const value = props.model[props.prop];
            return h('span', {}, 
              typeof value === 'number'
                ? value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 })
                : (value === 0 ? '0' : (value !== undefined && value !== null ? value : '0'))
            );
          }
        }
      ],



      datos: [ ...this.modelValue]


    };
  },

  components: {
    VGrid,
    //ComponenteLoading,
  },

  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },

    '$i18n.locale'() {
      
      this.columns = [
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.hora'),
          prop: "periodo",
          size: 90
          // Aquí no hace falta columnType, es entero
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa1'),
          prop: "ppa1",
          size: 200,
          columnType: 'numeric',
          columnTypeOptions: {
            decimalSeparator: ',',
            precision: 2
          }
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa2'),
          prop: "ppa2",
          size: 200,
          columnType: 'numeric',
          columnTypeOptions: {
            decimalSeparator: ',',
            precision: 2
          }
        },
        {
          name: this.$t('simulacion.modulo.ppa_perfiles.ppa3'),
          prop: "ppa3",
          size: 200,
          columnType: 'numeric',
          columnTypeOptions: {
            decimalSeparator: ',',
            precision: 2
          }
        }
      ];





    },


  },

  methods: {
      actualizarDatos(){
         this.datos=[ ...this.modelValue]
      },

         

    handleCellEdit(event) {
        console.log("Intercepta...");

        const { detail } = event;
        let inputValue = detail.val;

        // Paso 1 → Normalizar: siempre convertir coma a punto
        if (typeof inputValue === 'string') {
          inputValue = inputValue.replace(',', '.');
        }

        // Paso 2 → Convertir a número
        const newValue = Number(inputValue);

        // Paso 3 → Si no es número válido, ponemos 0 (o puedes decidir no tocarlo)
        const finalValue = isNaN(newValue) ? 0 : newValue;

        // Actualizar el modelo de la fila correspondiente
        const rowIndex = detail.rowIndex;
        this.datos[rowIndex][detail.prop] = finalValue;

        console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
      },



    exportToCSV() {
      const headers = this.columns.map((col) => col.name).join(";");
      const rows = this.datos.map((row) =>
        this.columns.map((col) => {
          const value = row[col.prop];
          // Si es número, formatear con coma
          if (typeof value === 'number') {
            return value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
          } else {
            return value !== undefined ? value : "";
          }
        }).join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "perfiles-ppa.csv";
      a.click();
      URL.revokeObjectURL(url);
    },

     //Función para utilizar el prop procesando el header de una columna, para que sea compatible con varios idiomas
     devolverPropColumnas(str,){
     const propEntry =Object.entries(this.traducciones).find(([,value ])=> {
       //console.log("Entrada de columnasEsperadas. Key: ", key , " Value:", value)
       //console.log("Value ", key," ",value.join(',') , "Se busca ", str)
       // Buscamos si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
       if (value.some(v => v ==str)) {
         //console.log(`Coincide con la clave: ${key}`);
         return true
       }
       });
       const prop = propEntry ? propEntry[0] : null;
       //console.log("Prop: ", propEntry);
       return prop;

   },
   //Funcion para ver que todas las cabeceras son correctas
    revisarCabeceras(header){
     let cabecerasFaltantes=[]
     header.forEach(value=>{
       //console.log("Valores de header: ", value)
       if(!this.devolverPropColumnas(value)){
       
         cabecerasFaltantes.push(value)
       }
     })
     console.log("Cabeceras faltantes: ", cabecerasFaltantes)
     //SI existen valores que faltan
     if(cabecerasFaltantes.length>0){
       //codigo de aviso:
       alert( this.$t('mensajes.alerta_cabeceras') +" ' "+ cabecerasFaltantes.join("', ' ")+ " ' ")
       return true;
     }
     else{
       return false;
     }
   },
    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },
    importFromCSV() {
      this.$refs.fileInput.click();
    },




    handleCSVUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const [headerLine, ...lines] = csvData
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0); // Eliminar líneas vacías
            const MAX_ROWS = 8760;
          if (lines.length > MAX_ROWS) {
            Swal.fire({
              icon: 'error',
              title: this.$t('mensajes.excel_demasiadas_filas_titulo') || 'Demasiadas filas',
              html:
                (this.$t('mensajes.excel_demasiadas_filas_texto') ||
                  'El fichero supera el máximo permitido.') +
                `<br><b>${lines.length.toLocaleString()}</b> filas detectadas. Máximo permitido: <b>${MAX_ROWS.toLocaleString()}</b>.`,
              confirmButtonText: 'OK',
            });
            event.target.value = ''; // resetea input
            return;
          }

          const delim = this.guess_delimiter(headerLine)
          console.log("delim: ", delim)
          const headers = headerLine.split(delim);

           //Revisar que están las cabeceras correctas
           if( this.revisarCabeceras(headers)){
            return
          }
          const header_prop=headers.map(header=>{
            return  this.devolverPropColumnas(header)
          })
          const importedData = lines.map((line,index) => {
            const values = line.split(delim);
            if(index+1 != Number(values[0])){
              this.error_msg="Se esperaba la hora "+ String(index+1) + " y se encontró la hora " + values[0]
              this.showAlert=true
              return {periodo:index+1 , ppa1:Number(values[1].replace(",", "."))
              ,ppa2:Number(values[2].replace(",", ".")),ppa3:Number(values[3].replace(",", "."))}
            }
            const obj = {};
            header_prop.forEach((header, index) => {
              const value = values[index];
              // Convertir a número si el valor parece numérico
              obj[header] = value === ""
                ? value
                : isNaN(Number(value.replace(",", ".")))
                  ? value
                  : Number(value.replace(",", "."));

            });
            return obj;
          });

          this.datos = [...importedData];
          this.$emit("update:modelValue", this.datos);
          //console.log(this.datos);
        };
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
    },
    formatNumber(value, decimals = 20) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '0';
      }
      return value.toFixed(decimals).replace('.', ',');
    },
    preparar_traducciones(){
            const keys = [
              'simulacion.modulo.ppa_perfiles.hora',
              'simulacion.modulo.ppa_perfiles.ppa1',
              'simulacion.modulo.ppa_perfiles.ppa2',
              'simulacion.modulo.ppa_perfiles.ppa3',
            ]
            const customKeys=[
                'periodo',
                'ppa1',
                'ppa2',
                'ppa3',
                ];
          const availableLocales = this.$i18n.availableLocales
          const messages = this.$i18n.messages

          keys.forEach((key, index) => {
        const pathSegments = key.split('.')
        const customKey = customKeys[index]

        const traducciones = availableLocales.map(lang => {
          const value = pathSegments.reduce((obj, segment) => obj?.[segment], messages[lang])
          return value
        }).filter(Boolean)

        this.traducciones[customKey] = traducciones
      })
      //console.log("Traducciones: ", this.traducciones)
    }


    
  },

  mounted() {
    this.preparar_traducciones();
  },


};
</script>

<style>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}
</style>

